import { AdvisorIcon } from '@jouzen/ecom-components/icons/AdvisorIcon';
import { DexcomFoodIcon } from '@jouzen/ecom-components/icons/DexcomFoodIcon';
import { DexcomWaveIcon } from '@jouzen/ecom-components/icons/DexcomWaveIcon';

import type { TextColProps } from '@/app/components/TwoColumnModule';

export const motionProps = {
  initial: { filter: 'blur(5px)', opacity: 0 },
  style: { height: '100%' },
  transition: { delay: 0.5, duration: 0.5 },
  viewport: { once: true },
  whileInView: { filter: 'blur(0px)', opacity: 1 },
};
const subtextClassName = 'text-base text-mustard-700';
const textClassName = subtextClassName + ' md:text-xl font-bold';

export const textCol: TextColProps = {
  titleProps: {
    label: 'metabolic_health_spec_title',
    className:
      'md:text-4xl text-2xl  text-mustard-700 font-normal md:font-light pb-8',
  },

  paragraphs: [
    {
      icon: DexcomWaveIcon,
      iconClassName: 'text-mustard-700',
      textProps: {
        label: 'metabolic_health_specs_header_tracking',
        className: textClassName,
        color: 'unset',
      },
      subtextProps: {
        label: 'metabolic_health_specs_tracking_subcopy',
        className: subtextClassName,
        color: 'unset',
      },
    },
    {
      icon: DexcomFoodIcon,
      iconClassName: 'text-mustard-700',
      textProps: {
        label: 'metabolic_health_specs_header_angles',
        className: textClassName,
        color: 'unset',
      },
      subtextProps: {
        label: 'metabolic_health_specs_angles_subcopy',
        className: subtextClassName,
        color: 'unset',
      },
    },
    {
      icon: AdvisorIcon,
      iconClassName: 'text-mustard-700',
      textProps: {
        label: 'metabolic_health_specs_header_fuel',
        className: textClassName,
        color: 'unset',
      },
      subtextProps: {
        label: 'metabolic_health_specs_fuel_subcopy',
        className: subtextClassName,
        color: 'unset',
      },
    },
  ],
};
